<template>
  <div v-if="model" class="flex min-w-50 flex-col">
    <div class="flex items-center space-x-2">
      <div class="h-4 w-4">
        <icon-base :icon="IconMessage" class="text-secondary-blue" />
      </div>
      <span v-tooltipable class="truncate text-headline">
        {{ model.message }}
      </span>
    </div>
    <div class="text-label">
      <date-and-time-display
        :value="model?.created_at || ''"
        :show-time-below-date="false"
      />
    </div>
  </div>
  <div v-else>-</div>
</template>
<script setup lang="ts">
import IconMessage from "@/components/icons/IconMessage.vue";
import IconBase from "@/components/ui/IconBase.vue";
import DateAndTimeDisplay from "@/components/ui/text/DateAndTimeDisplay.vue";

import type { SmsLogData } from "@/models/communicationLogs";

const { model } = defineProps<{ model: SmsLogData }>();
</script>
